export default {"src":"/_next/static/media/Arrow.451db8b4.svg","height":16,"width":29,"blurWidth":0,"blurHeight":0};